import Vue from "vue";
import VueRouter from "vue-router";
import http from "src/util/http";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Project",
    component: () => import("../views/Projects.vue"),
  },
  {
    path: "/projects/new",
    name: "AddProject",
    component: () => import("../views/AddProject.vue"),
  },
  {
    path: "/projects/:id",
    name: "EditProject",
    component: () => import("../views/AddProject.vue"),
    props: true,
  },
  {
    path: "/users",
    name: "User",
    component: () => import("../views/Users.vue"),
  },
  {
    path: "/clusters",
    name: "Cluster",
    component: () => import("../views/Clusters.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const tokenValid = async () => {
  try {
    await http().get("authorization");
    return true;
  } catch (err) {
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.name !== "Login" && !(await tokenValid())) {
    const loginpath = window.location.pathname;
    next({ name: "Login", query: { from: loginpath } });
  } else {
    next();
  }
});

export default router;
